/**
 * @voltxampere/ui — Reed relay variant (Sprint 44-5, placeholder)
 *
 * PLACEHOLDER. Magnetic reed switch + coil — düşük akım, hızlı
 * switching (≤1 ms), küçük paket. Coil current threshold → contact
 * state coupling Sprint 47+ engine extension #4 ile (paired
 * digital-gate + switch interlock pattern).
 *
 * Reference: Hamlin / Coto Technology HE721A — DIP-14, NO contact.
 * Coil 5 V DC / ~10 mA, contact 0.5 A @ 100 V DC. Hızlı küçük-yük
 * anahtarlama (multiplexer, instrument switching, sensor sampling).
 *
 * Engine zero-diff invariant honored — canonical `switch` engine
 * type via schemaType (output contacts).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { switchSymbol } from "../switch.js";
export const relayReed = {
    id: "relay-reed",
    nameTr: "Reed Relay (Hamlin HE721A, placeholder)",
    nameEn: "Reed Relay (Hamlin HE721A, placeholder)",
    shortcut: "S",
    category: "passive",
    viewBox: switchSymbol.viewBox,
    terminals: switchSymbol.terminals,
    defaultLabel: "K",
    defaultValue: "REED",
    schemaType: "switch",
    defaultParams: { closed: false, Ron: 1e-3, Roff: 1e9 },
    renderSVG: () => switchSymbol.renderSVG(),
};
//# sourceMappingURL=relay-reed.js.map